import { createTransform } from "redux-persist";

// braie filter kardan kar roie dadeha moghe load unload estefade mishe az local storage

const SetTransformRegister = createTransform(
  (inboundState, key) => {
    // console.log('inbound',key,inboundState)
    return inboundState;
  },
  (outboundState, key) => {
    // console.log('outbound',key,outboundState)
    return {
      ...outboundState,
      name: null,
      user_id: null,
      cellphone: null,
      errors: null,
      loading: false,
      success: false,
    };
  },
  // define which reducers this transform gets called for.
  { whitelist: ["register"] },
);

export default SetTransformRegister;
